export const TITLE = 'Clerk';
export const COLOR_PRIMARY = '#654BF6';
